import { createContext, useState } from "react";

export const Setting = createContext();

export default function Settings ({children}) {
    const [storeConfig, setStoreConfig] = useState([]);
    const [storeSociety, setStoreSociety] = useState([]);
    const [storeInvoice, setStoreInvoice] = useState([]);
    const [storeBusniessRules, setStoreBusniessRules] = useState([])

    const parent = {
        storeConfig, setStoreConfig,
        storeSociety, setStoreSociety,
        storeInvoice, setStoreInvoice,
        storeBusniessRules, setStoreBusniessRules,
    };

    return <Setting.Provider value={parent}>{children}</Setting.Provider>
}